module.exports = __webpack_public_path__ + "img/advance2.3ba3b0ca.png";